/* This file is autogenerated, see readme.md for instructions */
import FromStartAltSvgIcon from '@bloomreach/banana-theme/icons/from-start-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const FromStartAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <FromStartAltSvgIcon />
    </Icon>
  );
});

FromStartAltIcon.displayName = 'FromStartAltIcon';

export default FromStartAltIcon;
